export var fontFamily = {
    body: [
        'Bitter',
        'Helvetica',
        'Segoe UI',
        'sans-serif'
    ],
    heading: [
        'Montserrat',
        'Helvetica',
        'Segoe UI',
        'sans-serif'
    ]
};

//# sourceMappingURL=fontFamily.js.map